import { createFileRoute } from '@tanstack/react-router';

import { Platforms } from '@mint-sdk/api-bff';
import { FiltersIntegrations } from '@mint-sdk/api-integrations';
import { Metadata } from '@mint-sdk/api-mdm';
import { Connection } from '@mint-sdk/api-omni';

export const Route = createFileRoute('/_secured/external-data/integrations')({
  async loader({ context }) {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/integrations_v2');
    const isSettingsV2 = await context.isFlagEnabled(
      '@mint/arm',
      'settingsMint2',
    );

    const title = i18n.t('Integrations | MINT');

    const queryClient =
      await context.serviceLocator.getOrThrowInstance('queryClient');

    if (isSettingsV2) {
      const [, profile] = await context.serviceLocator.getInstance('profile');
      const companyId = profile?.getProfileData()?.profile.company.id;
      await context.prefetchQuery(
        Metadata.getContextMetadataQueryOptions({
          params: {
            fieldUrnIds: ['platform_v2'],
            companyId,
            context: 'integration',
          },
        }),
      );

      await context
        .prefetchQuery(
          Connection.getConnectionListV2({ params: { cache: 'skip' } }),
        )
        .catch(() => undefined);
    }

    !isSettingsV2 &&
      queryClient.ensureQueryData({
        ...Platforms.listQueryOptions({
          params: { excludeDeleted: true, excludeNotIntegrated: false },
        }),
        staleTime: 1000 * 60 * 5,
      });

    !isSettingsV2 &&
      queryClient.ensureQueryData({
        ...FiltersIntegrations.get({}),
        staleTime: 1000 * 60 * 5,
      });

    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
});
